import { render, staticRenderFns } from "./StoreJoinTabs.vue?vue&type=template&id=21a6d7b5&scoped=true&"
import script from "./StoreJoinTabs.vue?vue&type=script&lang=js&"
export * from "./StoreJoinTabs.vue?vue&type=script&lang=js&"
import style0 from "./StoreJoinTabs.vue?vue&type=style&index=0&id=21a6d7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6d7b5",
  null
  
)

export default component.exports